import styled from 'styled-components';
import { CLIP_HEIGHT } from '@src/constants/timeline';
import { COLOR } from '@src/styles/color';

export const StyledAppend = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: ${CLIP_HEIGHT}px;
  padding: 8px 16px 8px 8px;
  border: 0.5px solid ${COLOR.indigo[16]};
  border-radius: 8px;
  background: ${COLOR.white};
  color: ${COLOR.darkGray};
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background: ${COLOR.charcoal};
  }

  svg {
    font-size: 24px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
